export default {
  NOTIFICATION_INFO: 'info',
  NOTIFICATION_WARNING: 'warning',
  NOTIFICATION_SUCCESS: 'success',
  NOTIFICATION_ERROR: 'error',
  NOTIFICATIONS_REQUEST: 'NOTIFICATIONS_REQUEST',
  NOTIFICATIONS_SUCCESS: 'NOTIFICATIONS_SUCCESS',
  NOTIFICATIONS_FAILURE: 'NOTIFICATIONS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/NotificationsConstants.js